var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44414 6.90395H15.9972V4.01562H1.44414C0.646598 4.01562 0 4.66222 0 5.45976C0 6.2573 0.646598 6.90395 1.44414 6.90395Z",
    fill: "#5B5166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44414 12.6999H15.9972V9.81152H1.44414C0.646598 9.81152 0 10.4581 0 11.2557C0 12.0533 0.646598 12.6999 1.44414 12.6999Z",
    fill: "#5B5166"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44414 15.6069V15.607C0.646598 15.607 0 16.2535 0 17.0511C0 17.8487 0.646598 18.4953 1.44414 18.4953H11.5545C11.4403 18.1435 11.38 17.7725 11.38 17.392C11.38 16.7547 11.5471 16.1434 11.8592 15.6069H1.44414Z",
    fill: "#5B5166"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4652 16.1007C24.752 15.3875 23.5956 15.3875 22.8824 16.1007L21.3829 17.6003V1.99081C21.3829 0.982151 20.5652 0.164551 19.5566 0.164551C18.5479 0.164551 17.7302 0.982208 17.7302 1.99081V17.6003L16.2307 16.1007C15.5175 15.3876 14.3612 15.3875 13.648 16.1007C12.9347 16.814 12.9347 17.9703 13.648 18.6835L18.2649 23.3004C18.9767 24.0124 20.1345 24.0149 20.8482 23.3004L25.4652 18.6835C26.1783 17.9703 26.1784 16.814 25.4652 16.1007Z",
    fill: "#5B5166"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.345edccaae3199f95cea004d5b1974bc.svg";
export { ForwardRef as ReactComponent };